"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getUserAvatar = getUserAvatar;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../Icon");
var _style = require("./style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getUserAvatar(user) {
  if (user.avatar) {
    return user.avatar;
  }
  return 'https://s3.amazonaws.com/buffer-ui/Default+Avatar.png';
}
const NavBarMenu = props => {
  const {
    user,
    isImpersonation
  } = props;
  return /*#__PURE__*/_react.default.createElement(_style.NavBarStyled, Object.assign({}, props), /*#__PURE__*/_react.default.createElement(_style.NavBarUser, null, isImpersonation && ( /*#__PURE__*/_react.default.createElement(_style.NavBarImpersonating, {
    user: user,
    "aria-label": "You are impersonating a user"
  }, "Impersonating")), /*#__PURE__*/_react.default.createElement(_style.NavBarName, null, user.name), /*#__PURE__*/_react.default.createElement(_style.NavBarEmail, null, user.email)), /*#__PURE__*/_react.default.createElement(_style.NavBarAvatar, {
    avatar: getUserAvatar(user)
  }), /*#__PURE__*/_react.default.createElement(_style.NavBarChavron, null, /*#__PURE__*/_react.default.createElement(_Icon.ChevronDown, {
    color: "grayLight",
    size: "large"
  })));
};
NavBarMenu.propTypes = {
  user: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    email: _propTypes.default.string.isRequired
  }).isRequired,
  isImpersonation: _propTypes.default.bool
};
NavBarMenu.defaultProps = {
  isImpersonation: false
};
var _default = exports.default = NavBarMenu;